var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 16,
    height: 16,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4E5255",
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3883461,0 C12.8215482,0 13.9874214,1.15962806 13.9874214,2.58493022 C13.9874214,4.01025651 12.8215239,5.1699833 11.3883461,5.1699833 C10.6479,5.1699833 9.95636698,4.85869385 9.46626896,4.32314695 L5.04091092,7.00160572 C5.13725045,7.36007662 5.19802708,7.67621136 5.19802708,8 C5.19802708,8.32366695 5.13725102,8.63979873 5.02047027,8.93716531 L9.40276017,11.6856 C9.95631864,11.1412361 10.6478381,10.8300167 11.3883461,10.8300167 C12.8215239,10.8300167 13.9874214,11.9897435 13.9874214,13.4150698 C13.9874214,14.8402919 12.8215052,16 11.3883461,16 C9.95518703,16 8.78927082,14.8402919 8.78927082,13.4150698 C8.78927082,13.0915311 8.85007102,12.7754023 8.96683426,12.4777647 L4.58466176,9.72934728 C4.03112901,10.2738062 3.33961968,10.5850531 2.5990753,10.5850531 C1.16589744,10.5850531 0,9.42532629 0,8 C0,6.5747538 1.16594043,5.41494692 2.5990753,5.41494692 C3.33952142,5.41494692 4.03105439,5.72623637 4.52115242,6.26178327 L8.94638665,3.58344754 C8.85007651,3.22461166 8.78927082,2.90848472 8.78927082,2.58505308 C8.78927082,1.15972679 9.95516826,0 11.3883461,0 Z M11.3883461,11.690227 C10.4324546,11.690227 9.65471704,12.4638483 9.65471704,13.4149469 C9.65471704,14.3660456 10.4324546,15.1396669 11.3883461,15.1396669 C12.3442376,15.1396669 13.1219752,14.3660456 13.1219752,13.4149469 C13.1219752,12.4638483 12.3442376,11.690227 11.3883461,11.690227 Z M2.5990753,6.27528006 C1.64307996,6.27528006 0.86532273,7.04888175 0.86532273,8 C0.86532273,8.95111825 1.64307996,9.72471994 2.5990753,9.72471994 C3.55494442,9.72471994 4.33258086,8.95112087 4.33258086,8 C4.33258086,7.04887913 3.55494442,6.27528006 2.5990753,6.27528006 Z M11.3883461,0.860333145 C10.4324546,0.860333145 9.65471704,1.63395442 9.65471704,2.58505308 C9.65471704,3.5361517 10.4324546,4.30977299 11.3883461,4.30977299 C12.3442376,4.30977299 13.1219752,3.5361517 13.1219752,2.58505308 C13.1219752,1.63395441 12.3442376,0.860333145 11.3883461,0.860333145 Z",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBlue);
export default __webpack_public_path__ + "static/media/share_blue.0aefcd3c8632a65bb6f676247d0050e5.svg";
export { ForwardRef as ReactComponent };